<template>
  <li>
    <template v-if="filter.type == 'checkbox'">
      <a
        class="dropdown-toggle dropright"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span>{{filter.name}}</span>
        <div>{{ filter.state.text }}</div>
      </a>

      <div @click.stop class="dropdown-menu filter-submenu with-filter animate slideIn">
        <div class="filter-search">
          <form>
            <i class="cs-search"></i>
            <input
              ref="search"
              @keyup="onFilter($event.target.value)"
              @change="onChange"
              class="form-control"
              type="search"
              :placeholder="`${i18n.app.components.home.search_in} ${filter.name}`"
            />
          </form>
        </div>
        <ul class="select-all">
          <li>
            <a href @click.prevent="selectAll()">{{ i18n.app.button.select_all }}</a>
          </li>
          <li>/</li>
          <li>
            <a href @click.prevent="deselectAll()">{{ i18n.app.button.deselect_all }}</a>
          </li>
        </ul>
        <ul>
          <li
            v-for="(option, index) in getOptions()"
            v-bind:key="filter.key + '-' + option.value"
            class="form-check"
          >
            <input
              :id="'radio-' + filter.key + '-' + index"
              type="checkbox"
              :name="filter.key"
              class="form-check-input"
              @change="onCheckboxChange(option.selection, option); onChange()"
              v-model="option.selection"
            />
            <label class="form-check-label" :for="'radio-' + filter.key + '-' + index">
              <span></span>
              {{ option.text }}
            </label>
          </li>
        </ul>
      </div>
    </template>

    <template v-if="filter.type == 'radio'">
      <a class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span>{{filter.name}}</span>
        {{filter.state.text}}
      </a>

      <div @click.stop class="dropdown-menu filter-submenu with-filter animate slideIn">
        <ul>
          <li
            v-for="(option, index) in getOptions()"
            v-bind:key="filter.key + '-' + option.value"
            class="form-check"
          >
            <input
              class="form-check-input"
              v-model="option.selection"
              :name="filter.key"
              type="radio"
              :value="option.value"
              :id="'radio-' + filter.key + '-' + index"
            />
            <label class="form-check-label" :for="'radio-' + filter.key + '-' + index">
              <span></span>
              {{ option.text }}
            </label>
          </li>
        </ul>
      </div>
    </template>

    <template v-if="filter.type == 'number'">
      <a>
        <div class="filter-text">
          <span ib>{{filter.name}}</span>
          <input
            ib
            v-model="filter.state.value"
            @change="onTextChange($event.target.value)"
            type="number"
            class="form-control"
          />
        </div>
      </a>
    </template>
  </li>
</template>

<script>
import DepotService from "@/services/DepotService";
import { TextInput } from "@/components/common/form";

const depotService = new DepotService();

export default {
  name: "home-sidebar",
  props: ["filter"],
  components: {
    TextInput
  },
  data() {
    return {
      optionsFiltered: null
    };
  },
  mounted() {
    this.filter.ref = this;
  },
  methods: {
    getOptions() {
      return this.optionsFiltered || this.filter.options;
    },
    selectAll() {
      this.getOptions().forEach(item => (item.selection = true));
      this.updateFilterState();
    },
    deselectAll() {
      this.getOptions().forEach(item => (item.selection = false));
      this.updateFilterState();
    },
    onFilter(val) {
      if (val) {
        this.optionsFiltered = this.filter.options.filter(
          item => item.text.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      } else {
        this.optionsFiltered = null;
      }
    },
    updateFilterState(isOpened) {
      const oldText = this.filter.state.text;
      this.filter.updateState();
      const newText = this.filter.state.text;

      this.$forceUpdate();

      this.$emit(isOpened ? "open" : "close", this.filter);

      if (oldText != newText) {
        this.$emit("change", this.filter);
      }
    },
    onCheckboxChange(checked, option) {
      if (!checked && option.on_deselect) {
        this.$emit("consequence", option.on_deselect);
      } else if (checked && option.on_select) {
        this.$emit("consequence", option.on_select);
      }
    },
    onTextChange(value) {
      if (value && this.filter.on_value) {
        this.$emit("consequence", this.filter.on_value);
      } else if (!value && this.filter.on_empty) {
        this.$emit("consequence", this.filter.on_empty);
      }

      this.$emit("change", this.filter);
    },
    onChange(value) {
      this.updateFilterState();
    }
  }
};
</script>

